// extracted by mini-css-extract-plugin
module.exports = {"notices":"Notices-notices-bbf2"};